import axios from './axios';
import { connectSocket, disconnectSocket } from '../socket';

export const setSession = (accessToken?: string | null, refreshToken?: string | null): void => {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    if (refreshToken) localStorage.setItem('refreshToken', refreshToken);
    // Token is now in localStorage, so the socket's auth callback can read
    // it — open the realtime connection (no-op if already connected).
    connectSocket();
  } else {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    delete axios.defaults.headers.common.Authorization;
    // Logged out — tear down the socket so it doesn't keep retrying with a
    // stale/absent token.
    disconnectSocket();
  }
};
